const StepInfo = ({ info, cylinderSerialNo }) => {
  return (
    <>
      <h3 className="text-dark-blue font-figtreeBold md:pt-4 text-center text-lg md:text-2xl">
        {info.name} - ({cylinderSerialNo})
      </h3>
      <p className="text-gray-600 text-center text-sm  md:text-lg md:pt-1">{info.description}</p>
    </>
  );
};

export default StepInfo;
